(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerGroup = document.querySelector('.header-group');
      this.header2 = document.querySelector('.header--middle-left');
      this.headerContainer = document.querySelector('.header-container');

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.headerGroup.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.headerGroup.offsetHeight}px`);
      
      // Update headerBounds to include full header-group height
      this.headerBounds = {
        bottom: this.headerGroup.offsetHeight,
        top: 0
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop) {
        this.headerGroup.classList.add('scrolled-past-header');
        this.header2.classList.add('scrolled-past-header');
        this.headerContainer.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.headerGroup.classList.add('scrolled-past-header');
        this.header2.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.headerGroup.classList.remove('scrolled-past-header');
        this.header2.classList.remove('scrolled-past-header');
        this.headerContainer.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.headerGroup.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.headerGroup.classList.add('shopify-section-header-sticky', 'animate');
      this.headerGroup.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.headerGroup.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const closeDrawerBtn = document.getElementById("closeDrawerBtn")
  closeDrawerBtn.addEventListener('click', function (e) {
    e.preventDefault()
    document.body.style.transform = '';
    document.body.classList.remove("overflow-hidden-tablet")
    document.getElementById("Details-menu-drawer-container").removeAttribute("open")
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifeseeds-hero"] && !Shopify.designMode) return;
  try {
    
  let timer = null;

  const runVideoSupport = () => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      const videos = Array.from(document.querySelectorAll('.hero-video'));
      let changes = 0;

      videos.forEach((video) => {
        const sources = Array.from(video.querySelectorAll('[data-src]'));

        // Cleanup if run multiple times on resize screen
        sources.forEach((source) => {
          if (source.hasAttribute('src')) {
            source.removeAttribute('src');
            changes++;
          }
        });

        sources.some((source) => {
          const minWidth = source.hasAttribute('data-min-width')
            ? parseInt(source.getAttribute('data-min-width'))
            : null;

          if (!minWidth || minWidth <= window.innerWidth) {
            source.src = source.getAttribute('data-src');
            changes++;
            return;
          }
        });

        if (changes > 0) {
          video.load();
        }
      });
    }, 250);
  };

  runVideoSupport();

  window.addEventListener('resize', runVideoSupport);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifseeds-bg-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.lifeseeds-bg-video-element');

    const activate = (video) => {
      if (video.dataset.loaded === 'true') return;
      video.dataset.loaded = 'true';

      // Promote data-src to src so the browser begins downloading. The <source>
      // media attributes still decide which one applies (mobile vs desktop).
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.getAttribute('data-src');
      });

      // Restart the loop if playback ever ends (some browsers drop the loop
      // attribute on stalled autoplay).
      video.addEventListener('ended', () => video.play());

      video.load();
      const playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(() => {});
      }
    };

    // Defer the (large) video download until the section approaches the
    // viewport. Above-the-fold heroes trigger on first paint; below-the-fold
    // ones wait for the scroll. Falls back to eager load without IO support.
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              activate(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '200px 0px' }
      );
      videos.forEach((video) => observer.observe(video));
    } else {
      videos.forEach(activate);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
